/* eslint-disable */
import Axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import withErrorHandler from "../../../hoc/withErrorHandler/withErrorHandler";
import * as actions from "../../../store/actions/index";
import AttributesTable from "./attributesTable";
var md5 = require("md5");

class AddAttributes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      attribute: {
        id: "",
        name: "",
        // categoryLogoUrl: "",
        // aboutCategory: "",
        // categoryBannerUrl: "",
        // categoryChargeType: "",
      },
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(e) {
    const { name, value } = e.target;
    let attribute = { ...this.state.attribute };
    attribute[name] = value;
    this.setState({
      attribute: attribute,
    });
  } 

  handleSubmit(e) {
    e.preventDefault();
    let attribute = this.state.attribute;
    let timestamp = new Date().getUTCMilliseconds();
    attribute.id = md5(timestamp);
    this.setState({
      attribute: attribute,
    });
    this.props.onAddAttribute(attribute, this.props.attribute);
  }

  render() {
    let attribute = this.state.attribute;

    return (
      <div className="container">
        <h3 className="text-center mt-2">Attribute Management</h3>
        <hr />
        <button
          className="btn btn-primary btn-sm mb-2 p-2"
          style={{
            backgroundColor: "blue",
          }}
          data-toggle="modal"
          data-target=".bd-example-modal-lg"
        >
          Add Attribute
        </button>
        <div
          className="modal fade bd-example-modal-lg"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLongTitle">
                  Add Attribute
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <form onSubmit={this.handleSubmit}>
                  <div className="form-row">
                    <div className="form-group col-md-6">
                      <label htmlFor="name">Attribute Name</label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        id="name"
                        placeholder="Enter Attribute Name"
                        onChange={this.handleChange}
                        value={attribute.name}
                        required
                      />
                    </div>

                    <button
                      type="submit"
                      className="btn btn-sm btn-primary col-sm-2"
                      style={{
                        marginBottom: "1.1rem",
                        marginTop: "2rem",
                        backgroundColor: "green",
                      }}
                      // onClick={this.handleSubmit}
                      // data-dismiss="modal"
                      disabled={this.props.loading}
                    >
                      {this.props.loading ? "Saving" : "Save"}
                    </button>
                  </div>
                </form>
              </div> 
            </div>
          </div>
        </div>
        <AttributesTable />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.attributes.loading,
    editAttributeNameLoading: state.attributes.editAttributeNameLoading,
    attribute: state.attributes.attribute,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAddAttribute: (attribute, attributes) =>
      dispatch(actions.onAddAttribute(attribute, attributes)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(AddAttributes, Axios));
